import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Form from "@/views/Form.vue";
import SocioecForm from "@/views/SocioecForm.vue";
import Login from "@/views/Login.vue";
import UserAdmin from "@/views/UserAdmin.vue";
import Statistics from "@/views/Statistics.vue";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/form",
      name: "form",
      component: Form,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/users",
      name: "users",
      component: UserAdmin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/statistics",
      name: "statistics",
      component: Statistics,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/:id",
      name: "edit",
      component: Form,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/socioec/:id",
      name: "socioeconomic",
      component:  SocioecForm,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') && JSON.parse(localStorage.getItem('token')).n) {
      next()
      return
    }
    next()
  } else {
    next()
  }
})

export default router;
